export const API_TIMEOUT = 1000 * 10

export const DL_APPS_COUNT = 300

export const SORT_BY_NEW = '新着順'

export const SORT_BY_DOWNLOAD = 'ダウンロード順'

export const SORT_TYPES = [SORT_BY_NEW, SORT_BY_DOWNLOAD]
